// Nuxt Studio mutates the client SQLite WASM DB with drafts after activation
// (`host.document.db.upsert` → `generateRecordInsert`). Pages already mounted
// at activation time are hydrated from the prerendered payload, and Studio
// only fires `app:data:refresh` on subsequent edits — so the first view of
// `/blog` reflects the build, not drafts.
//
// Fix: once Studio's host is on `window` AND hydration is done, call
// `refreshNuxtData()`. That fires `app:data:refresh` for every key; Nuxt's
// asyncData treats `cause: 'refresh:hook'` as a forced re-execute (bypasses
// `getCachedData`), so handlers re-query the now draft-aware client SQLite.
//
// Crucially we do NOT touch `payload.data` directly — clearing it during
// hydration causes Vue mismatches as data refs flip to defaults mid-render.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const w = window as unknown as { useStudioHost?: unknown }
    const refresh = () => {
      refreshNuxtData()
    }
    if (w.useStudioHost) {
      refresh()
      return
    }
    const id = window.setInterval(() => {
      if (w.useStudioHost) {
        window.clearInterval(id)
        refresh()
      }
    }, 200)
    window.setTimeout(() => {
      window.clearInterval(id)
    }, 30_000)
  })
})
